import "Enum.js";
/** @namespace GLOBAL */
/**
 * @class
 * @extends Enum
 */
GLOBAL.YesNo = Static(Enum, /** @lends GLOBAL.YesNo */ {
    No: 0,
    Yes: 1,

    title: function(value) {
        switch (+value) {
            case this.No:
                return "Нет";
            case this.Yes:
                return "Да";
            default:
                return this.ParentCall();
        }
    }
});
